import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";

ChartJS.register(ArcElement, Tooltip);

const RevenueCollectionAge = ({ chart_data = [] }) => {
  if (!Array.isArray(chart_data) || chart_data.length === 0) {
    return <div>No data available</div>;
  }

  // ✅ Fixed order (important)
  const orderedBuckets = [
    "<30 days",
    "30-60 days",
    "60-90 days",
    "90-180 days",
    ">180 days"
  ];

  // ✅ Color mapping (matches your UI)
  const colorMap = {
    "<30 days": "#20b486",
    "30-60 days": "#27ae9e",
    "60-90 days": "#f39c12",
    "90-180 days": "#f97316",
    ">180 days": "#ef4444",
  };

  let user = {};
  let currencies = [];
  try {
      user = JSON.parse(localStorage.getItem("user") || "{}");
      currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
    } catch (error) {
      console.error(
        "Error reading currency data:",
        error
      );
    }

  const defaultCurrencyId = Number(user?.default_currency_id || 1);
  const selectedCurrency = currencies.find(
    (currency) => Number(currency.value) === defaultCurrencyId
  );
  const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
  // INR = L, all other currencies = K
  const amountSuffix = defaultCurrencyId === 1 ? "L" : "K";
  const amountDivisor = defaultCurrencyId === 1 ? 100000 : 1000;
  

    
  // ✅ Map values safely (handles mismatch/nulls)
  const values = orderedBuckets.map(bucket => {
    const item = chart_data.find(
      d => d.aging_bucket?.trim() === bucket
    );
    return item ? Number(item.collected_revenue) : 0;
  });

  const labels = orderedBuckets;
  const colors = orderedBuckets.map(bucket => colorMap[bucket]);

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        borderWidth: 0,
        spacing: 4,       // gap between slices
        borderRadius: 6,  // rounded edges
        hoverOffset: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "65%",
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const val = ctx.parsed || 0;
            return `${symbol} ${(val / amountDivisor).toFixed(2)} ${amountSuffix}`;
          },
        },
      },
    },
    centerTextPlugin: false,
  };

  return (
    <div className="d-flex flex-column align-items-center">
      
      {/* 🔵 Donut Chart */}
      <div style={{ width: 200, height: 200 }}>
        <Doughnut data={data} options={options} plugins={[]}/>
      </div>

      {/* 🟢 Legend (bottom like screenshot) */}
      <div className="d-flex flex-wrap justify-content-center mt-3 gap-3">
        {labels.map((label, i) => (
          <div key={i} className="d-flex align-items-center gap-2">
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: colors[i],
              }}
            />
            <span style={{ fontSize: 14, color: "#64748b" }}>
              {label}
            </span>
          </div>
        ))}
      </div>

    </div>
  );
};

export default RevenueCollectionAge;